import { useLocation } from "@reach/router"
import React from "react"
import { useRef, useState } from "react"
import {
  FacebookShareButton,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
  LinkedinShareButton,
  TwitterShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  EmailShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  TelegramIcon,
  WhatsappIcon,
  EmailIcon,
} from "react-share"
import { connect } from "react-redux"
import { getFakeAddres } from "../helpers/helper.properties"
import { getName } from "../helpers/helper.developments"
import { makeShareUrl } from "../helpers/helper.rendering"
import { graphql, useStaticQuery } from "gatsby"

const SocialModal = ({ property, development, novelty }) => {
  const { realEstate } = useStaticQuery(graphql`
    query {
      realEstate {
        keys {
          tokko
        }
        env {
          APISERVER
          TENANTID
          CLIENTID
        }
      }
    }
  `)

  const location = useLocation()

  const data = location?.href?.includes("novedad")
    ? novelty
    : location?.href?.includes("propiedad")
    ? property
    : development
  const url = property?.id
    ? makeShareUrl({
        CLIENTID: realEstate.env.CLIENTID,
        property: property,
        href: location?.href,
        isMediacore: realEstate.keys.tokko ? false : true,
      })
    : makeShareUrl({
        CLIENTID: realEstate.env.CLIENTID,
        development: development,
        href: location?.href,
        isMediacore: realEstate.keys.tokko ? false : true,
      })

  const title =
    "Te comparto " +
    (url?.includes("propiedad") ? "la siguiente propiedad " : "") +
    (url?.includes("emprendimiento") ? "el siguiente emprendimiento: " : "") +
    (url?.includes("venta") ? "en venta: " : "") +
    (url?.includes("temporario")
      ? "en alquiler temporario: "
      : url?.includes("alquiler")
      ? "en alquiler: "
      : "") +
    // (url?.includes("emprendimiento") ? getName(data) : (url?.includes("propiedad") ? getFakeAddres(data) + " " : '')) +
    (url?.includes("novedad") ? "la siguiente novedad: " : "")

  const formateMessage = str => {
    return encodeURIComponent(str)
      .replace(/[!'()]/g, escape)
      .replace(/\*/g, "%2A")
  }

  return data?.id ? (
    <div
      className="modal fade social-modal"
      id={"modal-social-" + data.id}
      tabindex="1066"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog modal-dialog-centered justify-content-center">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="staticBackdropLabel">
              Compartilo en tus redes sociales
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body align-items-center d-flex justify-content-center">
            <div className="d-flex justify-content-center align-items-center">
              <a
                className="mx-1"
                href={
                  "https://api.whatsapp.com/send?text=" +
                  title +
                  formateMessage(url.toString())
                }
                target="_blank"
              >
                <WhatsappIcon size={38} round />
              </a>
              <EmailShareButton
                className="mx-1"
                body={title + " " + url}
                subject={getFakeAddres(data)}
              >
                <EmailIcon size={38} round />
              </EmailShareButton>
              <FacebookMessengerShareButton
                className="mx-1"
                url={url}
                appId="521270401588372"
              >
                <FacebookMessengerIcon size={38} round />
              </FacebookMessengerShareButton>
              <TelegramShareButton className="mx-1" url={url} title={title}>
                <TelegramIcon size={38} round />
              </TelegramShareButton>
              <FacebookShareButton className="mx-1" url={url} quote={title}>
                <FacebookIcon size={38} round />
              </FacebookShareButton>
              <TwitterShareButton className="mx-1" url={url} title={title}>
                <i class={"icon-twitter circle-icon"} />
              </TwitterShareButton>
              <LinkedinShareButton
                url={url}
                source={url}
                title={title}
                className="mx-1"
              >
                <LinkedinIcon size={38} round />
              </LinkedinShareButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    ""
  )
}

export default connect(state => ({}), null)(SocialModal)
